module.exports = __webpack_public_path__ + "static/media/direction-down.0a375ba6.svg";